import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class BalikyNaPaleteGrid extends Component {
    state = {
        items: [],
        loading: false
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.items !== nextProps.items) {
            this.setState({ items: nextProps.items });
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        if (this.props.isUpdateRequest !== prevProps.isUpdateRequest) {
            this.props.getSelectedPaletaBaliky(this.state.items);
        }
    }

    lastSelectedIndex = 0;

    selectionChange = event => {
        event.dataItem.naPalete = !event.dataItem.naPalete;
        this.forceUpdate();
    };

    rowClick = event => {
        let last = this.lastSelectedIndex;
        const current = this.state.items.findIndex(dataItem => dataItem === event.dataItem);

        if (!event.nativeEvent.shiftKey) {
            this.lastSelectedIndex = last = current;
        }

        if (!event.nativeEvent.ctrlKey) {
            this.state.items.forEach(item => (item.naPalete = false));
        }
        const select = !event.dataItem.naPalete;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            this.state.items[i].naPalete = select;
        }

        this.forceUpdate();
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="BalikyNaPaleteGrid" onMouseDown={e => e.preventDefault() /* prevents browser text selection */}>
                <Grid data={items} selectedField="naPalete" onSelectionChange={this.selectionChange} onRowClick={this.rowClick}>
                    <GridColumn field="carovyKod" title={localizationService.toLanguageString("PaletyFRM.Balík", "Balík")} width="100px" />
                    <GridColumn field="skratka" title={localizationService.toLanguageString("PaletyFRM.Predajňa", "Predajňa")} />
                    <GridColumn field="typ" title={localizationService.toLanguageString("PaletyFRM.Typ", "Typ")} width="50px" />
                    <GridColumn field="pocetKusu" title={localizationService.toLanguageString("PaletyFRM.Ks", "Ks")} width="40px" />
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("PaletyFRM.Vytvorené", "Vytvorené")}
                        format="{0:d.M.yyyy H:mm}"
                        width="110px"
                    />
                    <GridColumn field="skenovalUzivatelJmeno" title={localizationService.toLanguageString("PaletyFRM.Vytvoril", "Vytvoril")} width="80px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default BalikyNaPaleteGrid;

registerForLocalization(BalikyNaPaleteGrid);



// WEBPACK FOOTER //
// ./src/components/dialogs/Paleta/BalikyNaPaleteGrid.js